import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../apiConfig";

const AdminLogin = () => {
  const [usuario, setUsuario] = useState("");
  const [contraseña, setContraseña] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/Admin/Login`,
        { usuario, contraseña },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        const { adminUsuario, adminNombre } = response.data; // 🔥 Obtenemos el nombre real del admin

        console.log("✅ Datos del admin recibidos:", response.data);

        localStorage.setItem("adminUsuario", adminUsuario); // 🔥 Guardamos el usuario del admin
        localStorage.setItem("adminNombre", adminNombre); // 🔥 Guardamos el nombre real

        navigate("/administradorMenu"); // 🔥 Redirigimos al menú del admin
      }
    } catch (error) {
      console.error("❌ Error en el login:", error);
      setError(error.response?.data?.message || "Usuario o contraseña incorrectos.");
    }
  };

  return (
    <div className="wrapper">
      <div className="form-box">
        <img src="/img/monytorlogoa.png" alt="Imagen de login" className="login-image" />
        <h2 className="text-XS">Login Administrador</h2>

        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="input-box">
            <input
              type="text"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              required
            />
            <label>Usuario</label>
          </div>
          <div className="input-box">
            <input
              type="password"
              value={contraseña}
              onChange={(e) => setContraseña(e.target.value)}
              required
            />
            <label>Contraseña</label>
          </div>
          <button type="submit" className="btn">Iniciar Sesión</button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
